import React, { useState } from "react";
import Layout from "../components/layout/Layout";
import { Search, ChevronLeft, ChevronRight, X } from "lucide-react";
import { Link } from "react-router-dom";
import CTASection from "../components/common/CTASection";
import Gallery1 from "../assets/gallery/1.jpg";
import Gallery2 from "../assets/gallery/2.jpg";
import Gallery3 from "../assets/gallery/3.jpg";
import Gallery4 from "../assets/gallery/4.jpg";
import Gallery5 from "../assets/gallery/5.jpg";
import Gallery6 from "../assets/gallery/6.jpg";
import Gallery7 from "../assets/gallery/7.jpg";
import Gallery8 from "../assets/gallery/8.jpg";
import Gallery9 from "../assets/gallery/9.jpg";
import Gallery10 from "../assets/gallery/10.jpg";
import Gallery11 from "../assets/gallery/11.jpeg";
import Gallery12 from "../assets/gallery/12.jpeg";
import Gallery13 from "../assets/gallery/13.jpeg";
import Gallery14 from "../assets/gallery/14.jpeg";
import Gallery15 from "../assets/gallery/15.jpeg";
import Gallery16 from "../assets/gallery/16.jpeg";
import Gallery17 from "../assets/gallery/17.jpeg";
import Gallery18 from "../assets/gallery/18.jpeg";
import Gallery19 from "../assets/gallery/19.jpeg";
import Gallery20 from "../assets/gallery/20.jpeg";
import Gallery21 from "../assets/gallery/21.jpeg";
import Gallery22 from "../assets/gallery/22.jpeg";
import Gallery23 from "../assets/gallery/23.jpeg";
import Gallery24 from "../assets/gallery/24.jpeg";
import Gallery25 from "../assets/gallery/25.jpeg";
import Gallery26 from "../assets/gallery/26.jpeg";
import Gallery27 from "../assets/gallery/27.jpeg";
import Gallery28 from "../assets/gallery/28.jpeg";
import Gallery29 from "../assets/gallery/29.jpeg";
import Gallery30 from "../assets/gallery/30.jpeg";
import Gallery31 from "../assets/gallery/31.jpeg";
import Gallery32 from "../assets/gallery/32.jpeg";
import hero from "../assets/galleryhero.jpg";

const GalleryPage = () => {
  const [filter, setFilter] = useState("*");
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const galleryItems = [
    { id: 1, category: "food", image: Gallery1, title: "Dish 1" },
    { id: 2, category: "food", image: Gallery2, title: "Dish 2" },
    { id: 3, category: "food", image: Gallery3, title: "Dish 3" },
    { id: 4, category: "food", image: Gallery4, title: "Dish 4" },
    { id: 5, category: "food", image: Gallery5, title: "Dish 5" },
    { id: 6, category: "food", image: Gallery6, title: "Dish 6" },
    { id: 7, category: "food", image: Gallery7, title: "Dish 7" },
    { id: 8, category: "food", image: Gallery8, title: "Dish 8" },
    { id: 9, category: "food", image: Gallery9, title: "Dish 9" },
    { id: 10, category: "food", image: Gallery10, title: "Dish 10" },
    { id: 11, category: "food", image: Gallery11, title: "Dish 11" },
    { id: 12, category: "food", image: Gallery12, title: "Dish 12" },
    { id: 13, category: "food", image: Gallery13, title: "Dish 13" },
    { id: 14, category: "food", image: Gallery14, title: "Dish 14" },
    { id: 15, category: "food", image: Gallery15, title: "Dish 15" },
    { id: 16, category: "food", image: Gallery16, title: "Dish 16" },
    { id: 17, category: "food", image: Gallery17, title: "Dish 17" },
    { id: 18, category: "food", image: Gallery18, title: "Dish 18" },
    { id: 19, category: "food", image: Gallery19, title: "Dish 19" },
    { id: 20, category: "food", image: Gallery20, title: "Dish 20" },
    { id: 21, category: "food", image: Gallery21, title: "Dish 21" },
    { id: 22, category: "food", image: Gallery22, title: "Dish 22" },
    { id: 23, category: "food", image: Gallery23, title: "Dish 23" },
    { id: 24, category: "food", image: Gallery24, title: "Dish 24" },
    { id: 25, category: "food", image: Gallery25, title: "Dish 25" },
    { id: 26, category: "food", image: Gallery26, title: "Dish 26" },
    { id: 27, category: "food", image: Gallery27, title: "Dish 27" },
    { id: 28, category: "food", image: Gallery28, title: "Dish 28" },
    { id: 29, category: "food", image: Gallery29, title: "Dish 29" },
    { id: 30, category: "food", image: Gallery30, title: "Dish 30" },
    { id: 31, category: "food", image: Gallery31, title: "Dish 31" },
    { id: 32, category: "food", image: Gallery32, title: "Dish 32" },
  ];

  const filteredItems =
    filter === "*"
      ? galleryItems
      : galleryItems.filter((item) => item.category === filter);

  const openLightbox = (index) => {
    setCurrentIndex(index);
    setSelectedImage(filteredItems[index].image);
  };

  const nextImage = () => {
    const newIndex = (currentIndex + 1) % filteredItems.length;
    setCurrentIndex(newIndex);
    setSelectedImage(filteredItems[newIndex].image);
  };

  const prevImage = () => {
    const newIndex =
      (currentIndex - 1 + filteredItems.length) % filteredItems.length;
    setCurrentIndex(newIndex);
    setSelectedImage(filteredItems[newIndex].image);
  };

  return (
    <Layout>
      {/* ===== HERO SECTION ===== */}
      <section
        className="relative py-16 sm:py-20 bg-fixed bg-cover bg-center"
        style={{
          backgroundImage: `url(${hero})`,
          backgroundAttachment: "fixed",
        }}
      >
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-[#2F3C7E]/70"></div>

        {/* Content */}
        <div className="container mx-auto px-4 text-center relative z-10">
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-3 sm:mb-4">
            Gallery
          </h1>
          <p className="text-lg sm:text-xl text-[#E6B325]">
            Moments of Excellence
          </p>
        </div>
      </section>

      {/* ===== GALLERY SECTION ===== */}
      <section className="py-12 sm:py-14 md:py-16 px-4 lg:px-8 bg-gray-50">
        <div className="container mx-auto">
          {/* Filter Navigation - Responsive */}
          {/*<div className="text-center mb-8 sm:mb-10 md:mb-12">
            <ul className="flex flex-wrap justify-center gap-3 sm:gap-4 md:gap-8 font-semibold text-xs sm:text-sm md:text-base uppercase">
              <li>
                <button 
                  onClick={() => setFilter('*')}
                  className={`pb-1 sm:pb-2 transition ${filter === '*' ? 'text-[#E6B325] border-b-2 border-[#E6B325]' : 'text-gray-600 hover:text-[#2F3C7E]'}`}
                >
                  All
                </button>
              </li>
              <li>
                <button 
                  onClick={() => setFilter('festival')}
                  className={`pb-1 sm:pb-2 transition ${filter === 'festival' ? 'text-[#E6B325] border-b-2 border-[#E6B325]' : 'text-gray-600 hover:text-[#2F3C7E]'}`}
                >
                  Festival
                </button>
              </li>
              <li>
                <button 
                  onClick={() => setFilter('food')}
                  className={`pb-1 sm:pb-2 transition ${filter === 'food' ? 'text-[#E6B325] border-b-2 border-[#E6B325]' : 'text-gray-600 hover:text-[#2F3C7E]'}`}
                >
                  Food
                </button>
              </li>
              <li>
                <button 
                  onClick={() => setFilter('hotel')}
                  className={`pb-1 sm:pb-2 transition ${filter === 'hotel' ? 'text-[#E6B325] border-b-2 border-[#E6B325]' : 'text-gray-600 hover:text-[#2F3C7E]'}`}
                >
                  Hotel
                </button>
              </li>
            </ul>
          </div>*/}

          {/* Gallery Grid - Responsive */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 sm:gap-5 md:gap-6">
            {filteredItems.map((item, index) => (
              <div
                key={item.id}
                className="group relative overflow-hidden rounded-lg shadow-md hover:shadow-xl transition cursor-pointer"
                onClick={() => openLightbox(index)}
              >
                <div className="aspect-w-4 aspect-h-3 bg-white">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-48 sm:h-56 md:h-64 object-cover transition duration-500 group-hover:scale-110"
                  />
                </div>
                <div className="absolute inset-0 bg-[#2F3C7E]/80 opacity-0 group-hover:opacity-100 transition duration-300 flex items-center justify-center">
                  <div className="bg-white rounded-full p-2 sm:p-3 transform scale-0 group-hover:scale-100 transition duration-300">
                    <Search className="w-4 h-4 sm:w-5 sm:h-5 text-[#2F3C7E]" />
                  </div>
                </div>
                {/* Image title on hover */}
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3 opacity-0 group-hover:opacity-100 transition duration-300">
                  <p className="text-white text-xs sm:text-sm font-medium truncate">
                    {item.title}
                  </p>
                </div>
              </div>
            ))}
          </div>

          {/* No results message */}
          {filteredItems.length === 0 && (
            <div className="text-center py-12">
              <p className="text-gray-500 text-base sm:text-lg">
                No images found in this category.
              </p>
            </div>
          )}
        </div>
      </section>

      {/* ===== CTA SECTION ===== */}
      <CTASection />

      {/* ===== LIGHTBOX MODAL ===== */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-3 sm:p-4"
          onClick={() => setSelectedImage(null)}
        >
          {/* Close button */}
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-3 right-3 sm:top-5 sm:right-5 md:top-8 md:right-8 text-white bg-black/60 hover:bg-black/80 rounded-full p-2 sm:p-3 transition z-20"
          >
            <X className="w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7" />
          </button>

          {/* Left navigation button */}
          {filteredItems.length > 1 && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                prevImage();
              }}
              className="absolute left-2 sm:left-3 md:left-5 lg:left-8 top-1/2 transform -translate-y-1/2 text-white bg-black/60 hover:bg-black/80 rounded-full p-2 sm:p-3 transition z-20"
            >
              <ChevronLeft className="w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7" />
            </button>
          )}

          {/* Right navigation button */}
          {filteredItems.length > 1 && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                nextImage();
              }}
              className="absolute right-2 sm:right-3 md:right-5 lg:right-8 top-1/2 transform -translate-y-1/2 text-white bg-black/60 hover:bg-black/80 rounded-full p-2 sm:p-3 transition z-20"
            >
              <ChevronRight className="w-5 h-5 sm:w-6 sm:h-6 md:w-7 md:h-7" />
            </button>
          )}

          {/* Image Container */}
          <div className="relative w-full max-w-4xl max-h-[80vh] flex flex-col items-center justify-center">
            <img
              src={selectedImage}
              alt="Gallery preview"
              className="w-auto h-auto max-w-full max-h-[70vh] object-contain rounded-lg"
            />

            {/* Image counter and title */}
            <div className="mt-4 flex flex-col sm:flex-row items-center gap-2 sm:gap-4 text-white">
              <div className="bg-black/60 rounded-full px-4 py-2 text-xs sm:text-sm">
                {currentIndex + 1} / {filteredItems.length}
              </div>
              <div className="bg-black/60 rounded-full px-4 py-2 text-xs sm:text-sm">
                {filteredItems[currentIndex]?.title}
              </div>
            </div>
          </div>
        </div>
      )}
    </Layout>
  );
};

export default GalleryPage;
